import { RESOURCES } from '../resources';
import { ApiService } from '@ligo/shared/utils';
import { LiteShareholder } from '@ligo/dashboard/store';

export const ShareholderService = {
  sendVerificationEmail(shareholderId: string) {
    return ApiService.patch<any, LiteShareholder>(
      RESOURCES.SEND_VERIFICATION_EMAIL(shareholderId), {}
    );
  }
};
